class Quotebar extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector(".quote-bar-slider");
    if (!swiperEl) return;
    const isMobile = window.matchMedia("(max-width: 990px)").matches;
    const mobileAutoScroll =
      this.dataset.mobileAutoScroll === "true";

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 24,
      loop: isMobile && mobileAutoScroll,

      speed: isMobile && mobileAutoScroll ? 6000 : 500,
      autoplay:
      isMobile && mobileAutoScroll
        ? {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }
        : false,

      breakpoints: {
        0: {
          slidesPerView: 2,
          loop: true,
        },
        540: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        991: {
          slidesPerView: 5,
          centeredSlides: false,
        }
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get("quote-bar")) {
  customElements.define("quote-bar", Quotebar);
}